/* eslint-disable no-nested-ternary */
import Moment from 'react-moment';
import { Box, Divider, Group, Stack, Text } from '@mantine/core';
import { IconPaperclip } from '@tabler/icons';
import { MessageS } from '../../Service/MessageS';
import Dot from '../../Atoms/Dot';
import MessagePlaceholderText from '../../Atoms/MessagePlaceholderText';
import { useParams } from 'react-router-dom';
import { ThemeText } from '../../Atoms/ThemeText';

const EmailHistoryListItem = ({ email, onClick, active }) => {

  const unread = email.localDateTime && !email.readTimestamp && !email.sendByUser;

  let contact = email.sendByUser ? (email.to && email.to.length > 0 ? email.to[0] : {}) : email.from;
  if (!contact) contact = {};

  return (
    <>
      <Stack
        p="sm"
        spacing={5}
        className="clickable"
        onClick={onClick}
        sx={(theme) => ({
          height: 95,
          borderLeft: active
            ? `5px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.silver[9]} `
            : 'none',
          backgroundColor: unread
            ? theme.colorScheme === 'dark'
              ? theme.colors.dark[5]
              : theme.colors.lightBlue[0]
            : 'inherit',
        })}
      >
        <Box pos="relative">
          <Group spacing="xs">
            {unread && <Dot withoutShadow size={8} colour="#1D5191" />}
            <Text
              className="overflow-ellipsis"
              size="md"
              weight="bolder"
              sx={(theme) => ({
                width: '75%',
                color: theme.colorScheme === 'dark' ? 'white' : 'black',
              })}
            >
              {contact.personDescription ? contact.personDescription : contact.email}
            </Text>
          </Group>
          <Box pos="absolute" right={0} top={0}>
            {!email.scheduledTime && (
              <ThemeText size="xs" align="right">
                {email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.localDateTime}</Moment>}
                {!email.localDateTime && <Moment calendar={MessageS.calendarStrings}>{email.lastModified}</Moment>}
              </ThemeText>
            )}
            {email.scheduledTime && (
              <ThemeText size="xs" align="right">
                <Moment fromNow calendar={MessageS.calendarStrings}>
                  {email.scheduledTime}
                </Moment>
              </ThemeText>
            )}
          </Box>
        </Box>
        <Box pos="relative">
          {email.subject && (
            <Text
              weight="bolder"
              className="overflow-ellipsis"
              sx={(theme) => ({ width: '90%', color: theme.colorScheme === 'dark' ? 'white' : 'black' })}
            >
              <MessagePlaceholderText email={email} value={email.subject} />
            </Text>
          )}
          {!email.subject && (
            <Text italic color="dimmed" weight="bolder">
              Kein Betreff
            </Text>
          )}
          {((email.attachments && email.attachments.length > 0) || email.countOfAttachments > 0) && (
            <Box pos="absolute" right={0} top={-5}>
              <IconPaperclip size={16} color="gray" />
            </Box>
          )}
        </Box>
        <Text color="dimmed" size="xs" className="overflow-ellipsis">
          <MessagePlaceholderText email={email} value={email.message} />
        </Text>
      </Stack>
      <Divider />
    </>
  );
};

export default EmailHistoryListItem;
